import { useEffect } from 'react'
import { useStateValue } from 'providers'
import {
  Route,
  Routes as RouteSwitch,
  useLocation,
  useNavigate
} from 'react-router-dom'
import { Login } from 'pages'

export const Routes = ({ children }) => {
  const [
    {
      session: { user }
    },
    dispatch
  ] = useStateValue()
  const params = new URLSearchParams(document.location.search)
  const resetToken = params.get('reset_token')
  const location = useLocation()

  const PUBLIC_PATHS = ['/beta', '/signup', '/login', '/logout', '/password_reset', '/change_password', '/games/wall', '/holidays']
  const navigate = useNavigate()
  useEffect(() => {
    if (location.pathname.indexOf('/guest/') === 0) {
      return navigate(location.pathname)
    }
    if (PUBLIC_PATHS.some((p) => location.pathname.startsWith(p))) return
    if (resetToken) navigate(`/change_password/${resetToken}`)
    if (!user && !resetToken) navigate('/logout')
  }, [user])

  return (
    <RouteSwitch>
      {children}
      <Route path="/*" element={<div>404 error.</div>} />
    </RouteSwitch>
  )
}
